<p-dialog 
header="Assign to Order" 
[(visible)]="showTrailerDialog" 
[modal]="true" 
[style]="{width: '600px'}"
styleClass="customer-dialog"
[closable]="false">
<ng-template pTemplate="header">
  <div class="flex justify-content-between align-items-center w-full">
    <div class="flex flex-column gap-1">
      <span class="text-xl font-bold">Assign to Order</span>
      <span class="text-sm text-600">
        {{ (!selectedOrder?.pickup_date || !selectedOrder?.delivery_date) && (!selectedOrder?.trailer_id && !selectedOrder?.external_trailer_number) 
          ? 'Configure trailer and schedule assignment'
          : (!selectedOrder?.trailer_id && !selectedOrder?.external_trailer_number) 
            ? 'Configure trailer assignment'
            : (!selectedOrder?.pickup_date || !selectedOrder?.delivery_date)
              ? 'Configure schedule assignment'
              : 'Assignment'
        }}
      </span>
    </div>
  </div>
</ng-template>
<div class="flex flex-column gap-4">
    <!-- Trailer Assignment Section -->
    <div class="surface-section p-4 border-round-lg shadow-1" 
         style="background-color: var(--surface-card);"
         *ngIf="!selectedOrder?.trailer_id && !selectedOrder?.external_trailer_number">
        <div class="text-lg font-semibold text-900 mb-4">
            <i class="pi pi-truck mr-2"></i>
            Trailer Assignment
        </div>
        
        <!-- Trailer Type Selection -->
        <div class="field mb-4">
            <label for="trailerType" class="block text-sm font-medium mb-3">Trailer Type</label>
            <p-selectButton 
                [options]="trailerTypeOptions" 
                [(ngModel)]="trailerType" 
                optionLabel="label" 
                optionValue="value"
                class="w-full">
            </p-selectButton>
        </div>

        <!-- Trailer Selection Fields -->
        <div class="field" *ngIf="trailerType === 'existing'">
            <span class="p-float-label w-full">
                <p-dropdown 
                    id="trailer"
                    [options]="trailerOptions"
                    [(ngModel)]="selectedTrailerId"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                    appendTo="body"
                    placeholder="Select a trailer"
                    [filter]="true"
                    [filterBy]="'label'"
                    [filterPlaceholder]="'Search trailers'"
                    [filterMatchMode]="'contains'"
                    [filterFields]="['label']"
                    >
                </p-dropdown>
                <label for="trailer">Select Trailer</label>
            </span>
        </div>

        <div class="field" *ngIf="trailerType === 'external'">
            <span class="p-float-label w-full">
                <input 
                    type="text" 
                    pInputText 
                    id="externalTrailer" 
                    [(ngModel)]="externalTrailerNumber" 
                    class="w-full">
                <label for="externalTrailer">External Trailer Number</label>
            </span>
        </div>

        <div class="field" *ngIf="trailerType === 'none'">
            <div class="p-4 border-round-lg bg-blue-50 border-blue-200 border-1">
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-info-circle text-blue-600"></i>
                    <span class="text-blue-700 font-medium">
                        Trailer assignment will be skipped. You can assign dates and proceed with driver assignment.
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!-- Schedule Assignment Section (only shown if dates are missing) -->
    <div class="surface-section p-4 border-round-lg shadow-1" 
         style="background-color: var(--surface-card);"
         *ngIf="!selectedOrder?.pickup_date || !selectedOrder?.delivery_date">
        <div class="text-lg font-semibold text-900 mb-4">
            <i class="pi pi-calendar mr-2"></i>
            Schedule Assignment
        </div>
        
        <!-- Date Fields in Two Columns -->
        <div class="grid">
            <!-- Pickup Date -->
            <div class="col-6" *ngIf="!selectedOrder?.pickup_date">
                <div class="field">
                    <label for="pickupDate" class="block text-sm font-medium mb-2">Pickup Date</label>
                    <p-calendar 
                        id="pickupDate"
                        [(ngModel)]="pickupDate" 
                        [showTime]="showPickupTime"
                        dateFormat="mm/dd/yy"
                        class="w-full"
                        placeholder="Select pickup date"
                        appendTo="body">
                    </p-calendar>
                    <div class="flex align-items-center gap-2 mt-2">
                        <p-checkbox 
                            [(ngModel)]="showPickupTime" 
                            [binary]="true"
                            inputId="pickup-time-toggle">
                        </p-checkbox>
                        <label for="pickup-time-toggle" class="text-sm text-600">Include specific time</label>
                    </div>
                </div>
            </div>
            
            <!-- Delivery Date -->
            <div class="col-6" *ngIf="!selectedOrder?.delivery_date">
                <div class="field">
                    <label for="deliveryDate" class="block text-sm font-medium mb-2">Delivery Date</label>
                    <p-calendar 
                        id="deliveryDate"
                        [(ngModel)]="deliveryDate" 
                        [showTime]="showDeliveryTime"
                        dateFormat="mm/dd/yy"
                        class="w-full"
                        placeholder="Select delivery date"
                        appendTo="body">
                    </p-calendar>
                    <div class="flex align-items-center gap-2 mt-2">
                        <p-checkbox 
                            [(ngModel)]="showDeliveryTime" 
                            [binary]="true"
                            inputId="delivery-time-toggle">
                        </p-checkbox>
                        <label for="delivery-time-toggle" class="text-sm text-600">Include specific time</label>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>
<ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
        <p-button 
            label="Skip" 
            icon="pi pi-times"
            (onClick)="skipTrailerAssignment()"
            styleClass="p-button-outlined">
        </p-button>
        <p-button 
            label="Assign" 
            icon="pi pi-check"
            (onClick)="assignTrailer()"
            [disabled]="trailerType === 'existing' && !selectedTrailerId && !selectedOrder?.pickup_date && !selectedOrder?.delivery_date"
            >
        </p-button>
    </div>
</ng-template>
</p-dialog>
